export default __webpack_public_path__ + "static/media/circle-left.96ae1398.svg";